import { Flex, Spin } from "@ir/ui";
import { Activity, memo } from "react";

const PromotionsLoadingSpinner = memo(({ isVisible }: { isVisible: boolean }) => (
  <Activity name="promotions-loading" mode={isVisible ? "visible" : "hidden"}>
    <Flex align="center" justifyContent="center" className="h-100">
      <Spin spinning aria-label="Loading promotions" />
    </Flex>
  </Activity>
));

PromotionsLoadingSpinner.displayName = "PromotionsLoadingSpinner";

export { PromotionsLoadingSpinner };
